import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

export const cognitoAuthConfig: UserManagerSettings = {
  authority: `https://cognito-idp.${import.meta.env.VITE_AWS_REGION}.amazonaws.com/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_COGNITO_SIGNOUT_URI,
  response_type: 'code',
  scope: 'email openid',
  monitorSession: true,
  automaticSilentRenew: true,
  silent_redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
};
